export default "__VITE_ASSET__sF0Qcw3A__"